import { API, Auth } from 'aws-amplify';

import {
  SET_LOGIN_STATE,
  SET_LOGIN_ERROR,
  SET_DIRECTORY_STRUCTURE,
  SET_DIRECTORY_PERMISSIONS,
  SET_CURRENT_DIRECTORY,
  SET_CURRENT_DIRECTORY_CONTENTS,
  SET_RELATED_FILES
} from './mutationTypes';

const getLoginState = async ({ commit }) => {
  try {
    await Auth.currentAuthenticatedUser();
    commit(SET_LOGIN_STATE, {
      loggedIn: true
    });
    commit(SET_LOGIN_ERROR, { error: null });
  } catch (error) {
    commit(SET_LOGIN_STATE, {
      loggedIn: false
    });
    commit(SET_LOGIN_ERROR, { error });
    console.log(error);
    throw error;
  }
};

/**
 * Gets the directory structure from the API by passing the RectordType to an endpoint.
 *
 * @param {ActionContext} [vuexContext]
 * @param {Object} params
 * @param {String} params.entity - the entity to get directory structure of
 */
const setupDirectoriesAndStructure = async ({ commit }, { entity }) => {
  const structureRes = await API.get('API', `/structure/${entity}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
  // const permissionsRes = await API.get('API', `/permissions/${entity}`, {
  //   headers: {
  //     Accept: 'application/json',
  //     'Content-Type': 'application/json'
  //   }
  // });

  // commit(SET_DIRECTORY_PERMISSIONS, {
  //   directoryPermissions: permissionsRes
  // });

  commit(SET_DIRECTORY_STRUCTURE, {
    directoryStructure: structureRes.children
  });
};

/**
 * Get directory contents from API
 *
 * @param {ActionContext} [vuexContext]
 * @param {Object} params
 * @param {String} params.entity - the entity to get contents of
 */
const getDirectoryContents = async ({ commit }, { entity }) => {
  const res = await API.get('API', `/files/${entity}`);

  commit(SET_CURRENT_DIRECTORY_CONTENTS, {
    directoryContents: res.records
  });
};

/**
 * Set directory and get files for directory. Shortcut for 2 operations
 *
 * @param {ActionContext} [vuexContext]
 * @param {Object} params
 * @param {String} params.path - the path of the new directory
 * @param {String} params.entity - the entity to get contents of
 */
const setDirectory = async ({ commit }, { path, entity }) => {
  commit(SET_CURRENT_DIRECTORY, {
    currentDirectory: path
  });

  const res = await API.get('API', `/files/${entity}`);

  commit(SET_CURRENT_DIRECTORY_CONTENTS, {
    directoryContents: res.records || []
  });
};


/**
 * Get related files from API
 *
 * @param {ActionContext} [vuexContext]
 * @param {Object} params
 * @param {String} params.entity - the entity
 * @param {String} params.domain - the entity's domain
 */
const loadRelatedFiles = async ({ commit }, { entity, domain }) => {
  const res = await API.get('API', `/related/${domain}/${entity}`);

  commit(SET_RELATED_FILES, {
    relatedFiles: res
  });
};

export default {
  getLoginState,
  getDirectoryContents,
  setupDirectoriesAndStructure,
  setDirectory,
  loadRelatedFiles
};
